/**
 * Header Routes Configuration
 *
 * Maps URL paths to header components displayed at the top of the page.
 * Each route path renders its corresponding header component.
 */
import React from 'react';
import { RouteProps } from 'react-router-dom';
import { dashboardPagesMenu } from '../menu';
import DashboardHeader from '../pages/_layout/_headers/DashboardHeader';

const headers: RouteProps[] = [
	{ path: dashboardPagesMenu.dashboard.path, element: <DashboardHeader /> },
	{
		path: `*`,
	},
];

export default headers;
